import { createReducer } from '@reduxjs/toolkit';
import { setDefaultAutocompleteSuggestions } from 'Core/actions/autocomplete.ts';
import { fromPayload } from 'Core/reducers/common.ts';

import type { AutocompleteItem } from 'Models/index.ts';

export default createReducer(null as AutocompleteItem[] | null, (builder) =>
  builder.addCase(setDefaultAutocompleteSuggestions, fromPayload),
);
